/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewManufacturerSuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore }: TypeProps = this.props;
    const parentForm: Object = this.props.parentForm;
    const model: Object = this.props.model;
    const childmodel: Object = this.props.childmodel;

    //Set Selected Trading Account
    parentForm.$('chooseAccount.tradingAccount').extra.selectID =
      actionDrawerStore.response.account_id;

    //Manufacturer
    const field: Object = parentForm.$('assetDetail.manufacturer');
    const fieldExtra: Object = field.extra;

    field.set('value', actionDrawerStore.response.name);
    field.set('extra', { ...fieldExtra, selectID: actionDrawerStore.response.id });
    model.loadData();

    //Reset Product
    //Maybe I should use same function from ElectroSelectExtra "setSelected"
    const fieldModel: Object = parentForm.$('assetDetail.model');
    const fieldModelExtra: Object = fieldModel.extra;

    fieldModel.set('value', '');
    fieldModel.set('extra', { ...fieldModelExtra, selectID: '' });
    fieldModel.set('extra', { ...fieldModelExtra, parentId: '' });
    parentForm.$('assetDetail.modelDescription').set('value', '');
    childmodel.filterId = actionDrawerStore.response.id;
    childmodel.parentId = actionDrawerStore.response.id;
    childmodel.loadData();

    actionDrawerStore.closeActionDrawer();
  }

  render(): React.Element<*> {
    return 'success';
  }
}
